import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { UnitType } from 'enums/unitType';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Unit/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	type: UnitType;
	factorToMilliliter: number | null;
	factorToGram: number | null;
	factorToOne: number | null;
	nameSingularTranslations: {
		[key: string]: string;
	};
	namePluralTranslations: {
		[key: string]: string;
	};
	shortNameSingularTranslations: {
		[key: string]: string;
	};
	shortNamePluralTranslations: {
		[key: string]: string;
	};
	synonyms: Synonyms;
	isAirDefinition: boolean;
};

export type UnitSynonymTranslation = {
	[key: string]: string;
};

export type Synonyms = {
	[key: string]: string[];
};
